var map = {
	"./bike.svg": 9320,
	"./course.svg": 2968,
	"./darts.svg": 5003,
	"./delete-photo.svg": 8449,
	"./headphones.svg": 930,
	"./nintendo.svg": 9024,
	"./pencil.svg": 3396,
	"./plus.svg": 2047,
	"./skates.svg": 8498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5163;